import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Linkedin } from "lucide-react";
import { nav } from "../mock";

const Col = ({ title, items }) => (
  <div>
    <h4 className="text-[13px] font-semibold uppercase tracking-wider text-white/60 mb-4">{title}</h4>
    <ul className="space-y-2.5">
      {items.map((it) => (
        <li key={it.label}>
          <Link to={it.to} className="text-[14px] text-white/80 hover:text-white transition-colors">{it.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export default function Footer() {
  return (
    <footer className="bg-lybl-greenDark text-white">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16">
        <div className="grid gap-12 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-full border border-white/40 flex items-center justify-center">
                <span className="font-serif text-white text-xl">L</span>
              </div>
              <div className="font-serif tracking-[0.18em] uppercase text-sm leading-tight">
                <p>Live Your</p><p>Best Life</p>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-[15px] text-white/70 leading-relaxed">
              Personalized holistic care that combines evidence-informed Ayurvedic frameworks with modern research and clinical data.
            </p>
            <div className="mt-6 flex items-center gap-4">
              {[Instagram, Facebook, Youtube, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="h-10 w-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors" aria-label="social">
                  <Icon className="h-4.5 w-4.5" />
                </a>
              ))}
            </div>
          </div>
          <Col title="Programs" items={nav.programs.slice(0, 6)} />
          <Col title="Explore" items={nav.explore} />
          <Col title="Learn" items={nav.learn} />
        </div>
        <div className="mt-14 pt-8 border-t border-white/15 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[13px] text-white/60">© {new Date().getFullYear()} Live Your Best Life. All rights reserved.</p>
          <div className="flex items-center gap-6 text-[13px] text-white/60">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms of Service</a>
            <a href="mailto:support@lybl.com" className="hover:text-white">support@lybl.com</a>
          </div>
        </div>
        <p className="mt-6 text-[12px] text-white/40 leading-relaxed max-w-3xl">
          These statements have not been evaluated by the Food and Drug Administration. LYBL is designed to complement conventional medical care, not replace it. *Results may vary depending on individual.
        </p>
      </div>
    </footer>
  );
}
